import { useApiQuery } from "@/hooks/useApiQuery";
import { apiCall } from "../../axios";

export const getAuthUser = () => {
  return new Promise((resolve, reject) => {
    return apiCall({ method: "get", url: `api/users/` })
      .then(resolve)
      .catch(reject);
  });
};

export const useGetAuthUser = (enabled) => {
  return useApiQuery({
    enabled,
    queryFn: async () => {
      try {
        return await getAuthUser();
      } catch (err) {
        console.error(err);
      }
      return null;
    },
    queryKey: ["authUser"],
  });
};

export default useGetAuthUser;
